import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";

export interface ReviewItem {
  workId: string;
  workTitle: string;
  genre: string;
  author: string;
  date: string;
  content: string;
}

interface Props {
  items: ReviewItem[];
}

export default function LatestReviews({ items }: Props) {
  return (
    <section>
      <SectionHeader title="最新影评短摘" subtitle="来自影评人的观察与解读，点击进入作品查看全文" />
      {items.length === 0 ? (
        <div className="rounded-lg border border-dashed border-background-300 bg-background-100/50 py-14 text-center">
          <p className="text-sm text-foreground-600">暂无影评内容</p>
        </div>
      ) : (
        <div className="rounded-lg border border-background-200 divide-y divide-background-200 overflow-hidden">
          {items.map((item, idx) => (
            <Link
              key={`${item.workId}-${idx}`}
              to={`/detail/${item.workId}`}
              className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-5 p-4 md:p-5 bg-background-50 hover:bg-background-100 transition-colors"
            >
              <div className="sm:w-40 shrink-0">
                <p className="font-heading font-semibold text-foreground-950 line-clamp-1">
                  {item.workTitle}
                </p>
                <span className="inline-block mt-1.5 text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                  {item.genre}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-700 leading-relaxed line-clamp-2">
                  {item.content}
                </p>
                <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-user-3-line" />
                  <span>{item.author}</span>
                  <span className="w-px h-3 bg-background-300" />
                  <span>{item.date}</span>
                </div>
              </div>
              <i className="ri-arrow-right-line text-foreground-400 self-center hidden sm:block" />
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}